import React, { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from "@mui/material";
import CampanhaCreateEdit from "./CampanhaCreateEdit";
import { post, postNoResponse } from "utils/WebService";
import { infoAviso, successAlert, warningAlert } from "utils/Functions";

export default function CampanhaConsult() {
  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);
    post("/campanha/list", {
      page: 0,
      pageSize: 100,
      sorted: [],
      filtered: []
    }).then(({ data }) => {
      setDataList(data || []);
    }).catch((e) => {
      console.error(e);
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEdit = (id) => {
    setSelectedId(id);
    setOpenModal(true);
  };

  const handleCreate = () => {
    setSelectedId(null);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    fetchData();
  };

  const handleDelete = (id) => {
    infoAviso("Deseja realmente excluir esta campanha?", async () => {
      postNoResponse(`/campanha/delete/${id}`).then(() => {
        successAlert("Campanha removida com sucesso!");
        fetchData();
      }).catch((e) => {
        warningAlert("Erro ao excluir campanha.");
      });
    }, () => null);
  };

  const getTipoLabel = (tipo) => {
    switch (Number(tipo)) {
      case 1: return <MDBadge badgeContent="Global (Devedor)" color="info" variant="gradient" size="sm" />;
      case 2: return <MDBadge badgeContent="Por Faixa de Atraso" color="warning" variant="gradient" size="sm" />;
      case 3: return <MDBadge badgeContent="Marcação Especial" color="secondary" variant="gradient" size="sm" />;
      case 4: return <MDBadge badgeContent="Por Ano de Vencimento" color="success" variant="gradient" size="sm" />;
      default: return "-";
    }
  };

  return (
    <MDBox pt={1} pb={3}>
      <Card>
        <MDBox p={3} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            Gestão de Campanhas e Regras
          </MDTypography>
          <MDButton variant="gradient" color="info" onClick={handleCreate} startIcon={<Icon>add</Icon>} size="small">
            Nova Campanha
          </MDButton>
        </MDBox>

        <MDBox p={3}>
          <TableContainer sx={{ boxShadow: "none" }}>
            <Table>
              <TableHead sx={{ display: "table-header-group" }}>
                <TableRow>
                  <TableCell align="left"><MDTypography variant="button" fontWeight="medium" color="text">Nome da Campanha</MDTypography></TableCell>
                  <TableCell align="center"><MDTypography variant="button" fontWeight="medium" color="text">Tipo</MDTypography></TableCell>
                  <TableCell align="center"><MDTypography variant="button" fontWeight="medium" color="text">Vigência</MDTypography></TableCell>
                  <TableCell align="center"><MDTypography variant="button" fontWeight="medium" color="text">Status</MDTypography></TableCell>
                  <TableCell align="center"><MDTypography variant="button" fontWeight="medium" color="text">Ações</MDTypography></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center"><MDTypography variant="button" fontWeight="regular" color="text">Carregando...</MDTypography></TableCell>
                  </TableRow>
                ) : dataList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center"><MDTypography variant="button" fontWeight="regular" color="text">Nenhuma campanha cadastrada.</MDTypography></TableCell>
                  </TableRow>
                ) : dataList.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      <MDBox display="flex" alignItems="center">
                        <MDTypography variant="button" fontWeight="regular" color="text">
                          {item.ccNome}
                        </MDTypography>
                        {item.cbPadrao && (
                          <MDBox ml={1}>
                            <MDBadge badgeContent="Padrão" color="primary" variant="contained" size="sm" />
                          </MDBox>
                        )}
                      </MDBox>
                    </TableCell>
                    <TableCell align="center">{getTipoLabel(item.cvTipoAplicacao)}</TableCell>
                    <TableCell align="center">
                      <MDTypography variant="button" fontWeight="regular" color="text">
                        {item.cdInicio ? `${new Date(item.cdInicio).toLocaleDateString()} até ${item.cdFim ? new Date(item.cdFim).toLocaleDateString() : 'Indefinida'}` : "Indefinida"}
                      </MDTypography>
                    </TableCell>
                    <TableCell align="center">
                      <MDTypography variant="button" fontWeight="regular" color={item.cbAtivo ? "success" : "error"}>
                        {item.cbAtivo ? "Ativo" : "Inativo"}
                      </MDTypography>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton color="info" onClick={() => handleEdit(item.id)}>
                        <Icon fontSize="small">edit</Icon>
                      </IconButton>
                      <IconButton color="error" onClick={() => handleDelete(item.id)}>
                        <Icon fontSize="small">delete</Icon>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </MDBox>
      </Card>

      {openModal && (
        <CampanhaCreateEdit 
          open={openModal} 
          onClose={handleClose} 
          id={selectedId} 
        />
      )}
    </MDBox>
  );
}
